import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Drawer,
  InputGroup,
  Tabs, Tab,
} from '@blueprintjs/core';
import {Translate, I18n} from 'react-redux-i18n';

import {
  closePreviewDialog,
} from './ExerciseBenchmarkActions';
import {
  sendMessage,
} from '../ExerciseRun/CommunicationBoxActions'
import style from './PreviewDialog.module.css';

class PreviewBenchmarkDialog extends Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      answers: [],
      // notes: (new Array(props.currentBenchmarks.length)).fill([]),
      notes: [],
      currentTab: "",
      expanded: false,
    }
  }
  
  componentDidUpdate(prevProps) {
    if(this.props.currentBenchmarks.length !== prevProps.currentBenchmarks.length) {
      this.setState({ 
        answers: (new Array(this.props.currentBenchmarks.length)).fill([]),
        currentTab: this.props.currentBenchmarks.length? this.props.currentBenchmarks[0]._id : "",
      })
    }
  }
  
  handleAnswer = (cIndex, index, aIndex) => {
    if(this.props.answerable) {
      this.setState((prevState)=>{
        const updatedAnswers = prevState.answers;
        updatedAnswers[cIndex] = updatedAnswers[cIndex] || [];
        updatedAnswers[cIndex][index] = aIndex;
        return { answers: updatedAnswers };
      }, ()=>{
        this.props.sendMessage(
          "",
          this.props.currentBenchmarks[cIndex].name + ": " + this.props.currentBenchmarks[cIndex].questions[index].title + "? " 
          + (this.props.currentBenchmarks[cIndex].questions[index].answers[aIndex]? this.props.currentBenchmarks[cIndex].questions[index].answers[aIndex] : "") 
          + (this.state.notes[cIndex]?.[index]? ` (Note: ${this.state.notes[cIndex][index]})` : ""),
          { preventWebClientPopup: true }
        )
      })
    }
  }
  
  render() {
    return (
      <Drawer
        autoFocus={true}
        canEscapeKeyClose={true}
        enforceFocus={true}
        isOpen={this.props.isPreviewBenchmarkDialogOpen}
        usePortal={true}
        hasBackdrop={false}
        position="right"
        canOutsideClickClose={false}
        onClose={this.props.closePreviewDialog}
        title={<h4><i className="fas fa-users" /><Translate value="exercise.Benchmarks"/></h4>}
        style={{width: this.state.expanded? "80%" : "50%", background: 'white'}}
        onOpening={()=>{
          if(!this.state.currentTab && this.props.currentBenchmarks.length) {
            this.setState({currentTab: this.props.currentBenchmarks[0]._id})
          }
        }}
      >
        {
          this.props.currentBenchmarks.length &&
            <div className="row" style={{paddingLeft: 20, paddingBottom: 10, overflowY: 'auto'}}>
              <div className="column centered" style={{padding: 5}}>
                {
                  this.state.expanded?
                  <i className="fas fa-angle-double-right pointer" onClick={()=>this.setState({expanded: false})} />
                  :
                  <i className="fas fa-angle-double-left pointer" onClick={()=>this.setState({expanded: true})} />
                }
              </div>
              <div className={`column centered`} style={{width: "93%", height: "max-content"}}>
                <Tabs
                  id="benchmarks-tabs"
                  onChange={(newTab)=>this.setState({ currentTab: newTab })}
                  selectedTabId={this.state.currentTab}
                  className={style.tabContainer}
                >
                {
                  this.props.currentBenchmarks.map((benchmark, cIndex) => (
                  <Tab
                    title={benchmark.name}
                    id={benchmark._id}
                    key={"c-"+cIndex}
                    panel={
                      <div className={`column centered ${style.mainContainer}`}>
                        <h4>{benchmark.name.toUpperCase()}</h4>
                        <table className={`${style.qtable}`}>
                          <tbody>
                          {
                            benchmark.questions.map((question, index) => (
                              <tr key={"q-"+index}>
                                <td>
                                  <span className={`${style.questionCount}`}>{index + 1}.</span>{question.title}  
                                </td>
                                <td>
                                  <React.Fragment>
                                    {
                                      question.answers.map((answer, aIndex) => (
                                        <span
                                          className={`${style.answer} ${this.props.answerable? "pointer" : ""} ${(this.state.answers[cIndex] && (this.state.answers[cIndex][index] === aIndex))? style.highlightedAnswer : ""}`}
                                          onClick={()=>this.handleAnswer(cIndex, index, aIndex)}
                                          key={"q-"+index+"-a-"+aIndex}
                                        >
                                          {answer}
                                        </span>
                                      ))
                                    }
                                  </React.Fragment>
                                </td>
                                {
                                  this.props.answerable &&
                                  <td>
                                    <input
                                      value={this.state.notes[cIndex]?.[index]}
                                      onChange={(event)=>{
                                        const data = event.target.value;
                                        this.setState((prevState)=>{
                                          const updatedNotes = prevState.notes;
                                          updatedNotes[cIndex] = updatedNotes[cIndex] || [];
                                          updatedNotes[cIndex][index] = data;
                                          return {notes: updatedNotes};
                                        })
                                      }}
                                      onKeyUp={(event) => {
                                        if(event.key === "Enter") {
                                          this.handleAnswer(cIndex, index, this.state.answers[cIndex][index]);
                                        }
                                      }}
                                      maxLength={200}
                                    />
                                  </td>
                                }
                              </tr> 
                            ))
                          }
                          </tbody>
                        </table>
                      </div>
                    }
                  />
                  ))
                }
                </Tabs>
              <div className="row" style={{marginTop: 10}}>
                <button
                  className={`btn btn-primary ${style.closeBtn}`} 
                  onClick={()=>{
                    const { answers, notes } = this.state;
                    window.open(`/print-evaluation?state=${encodeURIComponent(JSON.stringify({answers, notes, benchmarks: this.props.currentBenchmarks, exerciseName: this.props.exercise?.name, exerciseCode: this.props.exercise?.code}))}`, "_blank");
                  }}
                >
                  <Translate value="controls.Print" />
                </button>
                {/*<button className={`btn btn-primary ${style.closeBtn}`} style={{marginLeft: 3}} onClick={this.props.closePreviewDialog}><Translate value="controls.Close" /></button>*/}
              </div>
            </div>
          </div>
        }
      </Drawer>
    )
  }
}

const mapStateToProps = (state) => ({
  benchmark: state.exercise.benchmark,
  currentBenchmarks: state.exerciseBenchmark.currentBenchmarks,
  isPreviewBenchmarkDialogOpen: state.exerciseBenchmark.isPreviewBenchmarkDialogOpen,
  exercise: state.exercise.exercise,
});

const mapDispatchToProps = ({
  closePreviewDialog,
  sendMessage
})

export default connect(mapStateToProps, mapDispatchToProps)(PreviewBenchmarkDialog);